import React from "react";
import {
    CurrentUserType,
    errorMessage,
    getUserName,
    getUserNo,
    getSocketUrl,
    useWebsocket
} from "../../polyfills";
import { ChatContext, curSessionIdAtom, userAtom } from "../../store";
import { Provider } from "jotai";
import { message } from "antd";
import { useOnNewMessage } from "./useOnNewMessage";
import { useOnFeedback } from "./useOnFeedback";
import { makeSenderFlag } from "../../Utils/common";
import { ReceiverType } from "../../types";
import { PrimitiveAtom } from "jotai/core/atom";

interface WebIMProviderProps {
    initSession?: string;
    children: React.ReactNode;
}

function WebIMProviderInner({ children }: WebIMProviderProps) {
    const onNewMessage = useOnNewMessage();
    const onFeedback = useOnFeedback();

    const { sendMessage } = useWebsocket({
        url: getSocketUrl(), // 此参数为websocket地址
        onMessage(msg: any) {
            if (!msg) return;
            onReceiveFromSocket(msg);
        }
    });

    function onReceiveFromSocket(msg: any) {
        try {
            if (msg.businessKey === "chat") {
                const message = JSON.parse(msg.messageJson);
                return onNewMessage(message);
            }

            if ("success" in msg) {
                return onFeedback(msg);
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <ChatContext.Provider value={{ sendMessage }}>
            {children}
        </ChatContext.Provider>
    );
}

export default function WebIMProvider({
    initSession,
    children
}: WebIMProviderProps) {
    type AtomValueType<T> = T extends PrimitiveAtom<infer Value> ? Value : any;

    const userAtomValue: AtomValueType<typeof userAtom> = {
        isStu: (CurrentUserType as string) === ReceiverType.Student,
        userNo: getUserNo(),
        userName: getUserName(),
        senderFlag: makeSenderFlag({
            no: getUserNo(),
            type: CurrentUserType
        })
    };

    return (
        <React.Suspense
            fallback={<div style={{ textAlign: "center" }}>正在加载...</div>}>
            <Provider
                initialValues={
                    [
                        [curSessionIdAtom, initSession],
                        [userAtom, userAtomValue]
                    ] as any
                }>
                <WebIMProviderInner>{children}</WebIMProviderInner>
            </Provider>
        </React.Suspense>
    );
}
